import React, { useEffect, useState } from 'react';
import styles from '../../assets/scss/Billing/AddBilling.module.scss';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../Components/Common/Pagination';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import AddIBillingPopup from './AddIBillingPopup';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';
import { toast } from 'react-toastify';
import { useCreateBillingMutation, useGetBillingCustomersQuery, useGetLogisticsQuery, useGetSingleBillingQuery, useGetTempEmployeesDropdownQuery, useUpdateOverallBillMutation } from '../../slices/admin/admin';
import Select from "react-select";
import InvoiceDesignAddBilling from './InvoiceDesignAddBilling';

const AddBilling = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [items, setItems] = useState([]);

    const [transportPersonId, setTransportPersonId] = useState('');
    const [loadHandlerId, setLoadHandlerId] = useState('');

    // Add these queries (assuming RTK Query endpoints exist or add them)
    const { data: transportData } = useGetTempEmployeesDropdownQuery({ empDesignation: 'transportPerson' });
    const { data: loadHandlerData } = useGetTempEmployeesDropdownQuery({ empDesignation: 'loadHandler' });

    const transportList = transportData?.result || [];
    const loadHandlerList = loadHandlerData?.result || [];

    console.log(editingItem, "editingItem");

    const [billingItems, setBillingItems] = useState([]);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [confirmModalOpen, setConfirmModalOpen] = useState(false);


    //console.log(items, "items66666");
    const [logisticsId, setLogisticsId] = useState('');

    const { data: logisticsData } = useGetLogisticsQuery();
    const logisticsList = logisticsData?.logistics || [];

    //console.log("logisticsList", logisticsList);


    const [editingIndex, setEditingIndex] = useState(null);
    const [isAddingNewCustomer, setIsAddingNewCustomer] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [newCustomerName, setNewCustomerName] = useState('');
    const [newCustomerPhone, setNewCustomerPhone] = useState('');
    const [ownerName, setOwnerName] = useState('');
    const [ownerPhone, setOwnerPhone] = useState('');

    // console.log(editingIndex, "editingIndex");


    const [paymentMethod, setPaymentMethod] = useState('');
    const [logisticCharge, setLogisticCharge] = useState('');
    const [handleCharge, setHandleCharge] = useState('');
    const [boxCount, setBoxCount] = useState('');
    const [sackCount, setSackCount] = useState('');

    // save and print code start
    const [confirmModalOpens, setConfirmModalOpens] = useState(false);
    const [printData, setPrintData] = useState(null);
    const [showInvoice, setShowInvoice] = useState(false);
    // save and print code end

    console.log(printData, "printData333");


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const billId = searchParams.get("id");
    const mode = searchParams.get("mode") || "add"; // add, edit, view


    const extractProductName = (desc) => {
        if (!desc) return "";

        // Match the pattern: Name - ID number - ProductName - Quantity
        const parts = desc.split(" - ");
        if (parts.length >= 3) {
            // parts[2] should be productName
            return parts[2].trim();
        }

        return "";
    };


    const [updateOverallBill, { isLoading: updating }] = useUpdateOverallBillMutation();


    const { data: apiResponse, isLoading: billLoading } = useGetSingleBillingQuery(billId, {
        skip: !billId,
    });

    console.log(apiResponse, "apiResponse");



    useEffect(() => {
        if (billLoading) return;

        const billData = apiResponse?.data?.[0] || {};

        if (mode === "edit" || mode === "view") {
            setSelectedCustomer(billData.customerId || "");
            setOwnerName(billData.customer?.firstName || "");
            setOwnerPhone(billData.customer?.phone || "");
            setHandleCharge(billData.handleCharge || 0);
            setLogisticCharge(billData.logisticCharge || 0);
            //  setLogisticsId(billData.logisticId || "");
            setPaymentMethod(billData.paymentMethod || "");
            setTransportPersonId(billData.transportPersonId?._id || billData.transportPersonId || "");
            setLoadHandlerId(billData.loadHandlerId?._id || billData.loadHandlerId || "");
            setSackCount(billData.assetDetails?.sackCount || 0);
            setBoxCount(billData.assetDetails?.boxCount || 0);

            const mappedItems = (billData.items || []).map(it => {
                const override = it.overrideOption ?? it.itemId?.overrideOption ?? false;
                let price = 0;

                if (mode === "view") {
                    price = it.price ?? 0;
                } else if (mode === "edit") {

                    price = override
                        ? (it.itemId?.overallPrice ?? 0)
                        : ((!it.price || Number(it.price) <= 0)
                            ? (it.itemId?.overallPrice ?? 0)
                            : it.price);
                }

                const inventoryId = it.itemId?.inventoryId?.inventoryId || "-";
                const itemId = it.itemId?.itemId || "-";
                const farmerFirstName = it.itemId?.inventoryId?.farmerId?.firstName || "-";
                const farmerLastName = it.itemId?.inventoryId?.farmerId?.lastName || "";
                const displayId = inventoryId !== "-" ? `${itemId} - ${farmerFirstName}` : "-";

                return {
                    _id: it._id || "",
                    selectedItemId: it.itemId?._id || "",
                    itemIdNumber: it.itemId?.itemId || "",
                    displayId,
                    item: it.productName || it.itemId?.productName || "-",
                    quantity: Number(it.productQuantity ?? it.quantity ?? 0),
                    overallQuantity: it.itemId?.overallQuantity || 0,
                    quality: it.itemId?.productQuality || "-",
                    bag: it.itemId?.productBag || "-",
                    price: Number(price),
                    buyingPrice: Number(it.itemId?.buyingPrice ?? 0),
                    sellingPrice: Number(it.itemId?.sellingPrice ?? 0),
                    overrideOption: override,
                    description: it.itemId?.description || "-"
                };
            });

            setItems(mappedItems);

            // console.log(mappedItems, "mappedItems");


            localStorage.setItem("billingItems", JSON.stringify(mappedItems));
        }
        else if (mode === "add") {
            setSelectedCustomer("");
            setOwnerName("");
            setOwnerPhone("");
            setPaymentMethod("");
            setLogisticsId("");
            setLogisticCharge(0);
            setHandleCharge(0);
            setItems([]);
            localStorage.removeItem("billingItems");
        }
    }, [apiResponse, mode, billLoading]);


    const extractItemId = (desc) => {
        if (!desc) return "-";

        const match = desc.match(/Item ID\s*(\d+)/i);
        if (match) {
            return `Item ID ${match[1]}`;
        }

        return "-";
    };


    const extractItemCategory = (desc) => {
        if (!desc) return "-";

        // Format: name - ID number - productName - quantity
        const parts = desc.split(" - ");
        if (parts.length >= 3) {
            return parts[2].trim(); // the category/productName
        }

        return "-";
    };




    const {
        data: customerData,
        isLoading: customerLoading,
        error: customerError,
    } = useGetBillingCustomersQuery();

    const predefinedCustomers = customerData?.items || [];

    console.log(predefinedCustomers, "predefinedCustomers");


    const [createBilling, { isLoading: creating }] = useCreateBillingMutation();


    const openPopup = () => {
        setEditingItem(null);
        setIsPopupOpen(true);
    };

    const closePopup = () => setIsPopupOpen(false);

    const handleClose = () => {
        localStorage.removeItem('billingItems');
        setItems([]);
        navigate('/dashboard/billing');
    };

    const refreshItems = () => {
        const storedItems = JSON.parse(localStorage.getItem('billingItems') || '[]');
        setItems(storedItems);
    };

    useEffect(() => {
        refreshItems();
    }, [isPopupOpen]);

    const itemTotal = items.reduce((sum, item) => {
        const price = Number(
            item?.price && Number(item?.price) !== 0
                ? item?.price
                : item?.itemId?.overallPrice ?? item?.sellingPrice ?? 0
        );
        const qty = Number(item.quantity || 0);
        return sum + price * qty;
    }, 0);

    useEffect(() => {
        if (mode === "view" && apiResponse?.data?.[0]) {
            const billData = apiResponse.data[0];
            const preparedData = {
                ...billData,
                items: billData.items || [],
                customer: billData.customer || { firstName: ownerName, phone: ownerPhone }
            };
            setPrintData(preparedData);
        }
    }, [mode, apiResponse, ownerName, ownerPhone]);


    const totalAmount = itemTotal + Number(handleCharge || 0) + Number(logisticCharge || 0);


    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem('billingItems') || '[]');
        setBillingItems(storedItems);
    }, []);


    useEffect(() => {
        if (isAddingNewCustomer) {
            setOwnerName(newCustomerName);
            setOwnerPhone(newCustomerPhone);
        } else if (selectedCustomer && predefinedCustomers.length > 0) {
            const selected = predefinedCustomers.find(c => c._id === selectedCustomer);
            setOwnerName(selected?.firstName || '');
            setOwnerPhone(selected?.phone || '');
        } else {
            setOwnerName('');
            setOwnerPhone('');
        }
    }, [selectedCustomer, newCustomerName, newCustomerPhone, isAddingNewCustomer, predefinedCustomers]);


    const confirmDelete = (index) => {
        const actualIndex = (currentPage - 1) * limit + index;
        setDeleteIndex(actualIndex);
        setDeleteConfirmOpen(true);
    };

    const handleConfirmedDelete = () => {
        const updatedItems = [...items];
        updatedItems.splice(deleteIndex, 1);
        localStorage.setItem('billingItems', JSON.stringify(updatedItems));
        setItems(updatedItems);
        setDeleteConfirmOpen(false);
        setDeleteIndex(null);
        toast.success('Item deleted successfully!');
    };

    const totalPages = Math.ceil(items.length / limit);
    const paginatedItems = items.slice((currentPage - 1) * limit, currentPage * limit);

    //console.log(paginatedItems,"paginatedItems");






    const handleSubmit = async () => {
        if (!ownerName.trim() || !ownerPhone.trim()) {
            toast.error("Please select or add a customer.");
            return;
        }
        const missingItemId = items.find(item => !item.selectedItemId || item.selectedItemId.trim() === "");
        if (missingItemId) {
            toast.error(`Item "${missingItemId.description || "Unknown"}" is missing item ID. Please re-add it.`);
            return;
        }
        if (!/^[6-9]\d{9}$/.test(ownerPhone)) {
            toast.error("Please enter a valid 10-digit phone number.");
            return;
        }
        if (!paymentMethod) {
            toast.error("Please select a payment method.");
            return;
        }
        if (items.length === 0) {
            toast.error("Please add at least one item.");
            return;
        }
        if (
            handleCharge === '' || isNaN(handleCharge) || Number(handleCharge) < 0 ||
            logisticCharge === '' || isNaN(logisticCharge) || Number(logisticCharge) < 0
        ) {
            toast.error("Please enter valid logistic and handling charges.");
            return;
        }
        if (totalAmount > 20000) {
            toast.warning(
                "⚠️ Total amount exceeds ₹20,000. Please verify the amount type before proceeding!"
            );
        }
        // Load Handler selected → Handling Charge required
        if (loadHandlerId && (handleCharge === '' || isNaN(handleCharge) || Number(handleCharge) <= 0)) {
            toast.error("Please enter a valid Handling Charge for the selected Load Handler.");
            return;
        }

        // Transport Person selected → Transport Charge required
        if (transportPersonId && (logisticCharge === '' || isNaN(logisticCharge) || Number(logisticCharge) <= 0)) {
            toast.error("Please enter a valid Transport Person Charge for the selected Transport Person.");
            return;
        }


        // ✅ Price validation for all items
        // const invalidPriceItem = items.find(item => !item.price || Number(item.price) <= 0);
        // if (invalidPriceItem) {
        //     toast.error(`Please add a valid price for item: ${invalidPriceItem.item || "Unknown"}`);
        //     return;
        // }

        // ✅ Improved price validation with fallback logic
        const invalidPriceItem = items.find(item => {
            const effectivePrice =
                Number(item?.price) > 0
                    ? Number(item.price)
                    : Number(item?.itemId?.overallPrice) > 0
                        ? Number(item.itemId.overallPrice)
                        : Number(item?.sellingPrice) > 0
                            ? Number(item.sellingPrice)
                            : 0;

            return effectivePrice <= 0; // invalid if still 0 or missing
        });

        if (invalidPriceItem) {
            toast.error(`Please add a valid price for item: ${invalidPriceItem.item || "Unknown"}`);
            return;
        }


        if (mode === 'add') {
            const formattedItems = items.map(item => ({
                itemId: item.selectedItemId || '',
                // productName: item.item,
                productName: extractProductName(item.description),
                productQuantity: Number(item.quantity),
                productQuality: item.quality,
                price: Number(item.price || 0)
            }));

            const payload = {
                userName: ownerName,
                phoneNumber: ownerPhone,
                paymentMethod,
                logisticCharge: Number(logisticCharge),
                handleCharge: Number(handleCharge),
                billingItems: formattedItems,
                // logisticId: logisticsId,
                transportPersonId,
                loadHandlerId,
                sackCount: Number(sackCount) || 0,
                boxCount: Number(boxCount) || 0,
            };

            try {
                await createBilling(payload).unwrap();
                toast.success("Billing created successfully!");
                localStorage.removeItem('billingItems');
                navigate('/dashboard/billing');
            } catch (err) {
                toast.error("Failed to create billing.");
                console.error("Billing API error:", err);
            }
        }
        else if (mode === 'edit') {
            // const formattedBillingItems = items.map(item => ({
            //     billingItemId: item._id,
            //     productQuantity: Number(item.quantity),
            //     price: Number(item.price)
            // }));

            const formattedBillingItems = items.map(item => {
                // ✅ Use entered price if available, else fallback to existing sellingPrice
                const effectivePrice =
                    Number(item?.price) > 0
                        ? Number(item.price)
                        : Number(item?.sellingPrice) > 0
                            ? Number(item.sellingPrice)
                            : 0;

                return {
                    billingItemId: item._id,
                    productQuantity: Number(item.quantity),
                    price: effectivePrice // ✅ Only this field is sent
                };
            });


            const payload = {
                handleCharge: Number(handleCharge),
                logisticCharge: Number(logisticCharge),
                //logisticId: logisticsId,
                paymentMethod,
                billingItems: formattedBillingItems,
                transportPersonId,
                loadHandlerId,
                sackCount: Number(sackCount) || 0,
                boxCount: Number(boxCount) || 0,
            };

            try {
                const res = await updateOverallBill({ billId, payload }).unwrap();
                toast.success(res?.message || "Bill updated successfully!");
                navigate('/dashboard/billing');
            } catch (err) {
                toast.error("Failed to update bill.");
                console.error("Update API error:", err);
            }
        }
    };

    const [confirmModalOpenss, setConfirmModalOpenss] = useState(false);

    // const handleSaveClick = () => {
    //     if (mode === "edit") {
    //         setConfirmModalOpen(true);
    //     } else {
    //         handleSubmit();
    //     }
    // };

    const handleSaveClick = () => {
        setConfirmModalOpenss(true); // Always show confirmation before saving
    };


    const handleConfirmSave = async () => {
        setConfirmModalOpenss(false);
        await handleSubmit(); // Proceed with your existing submit logic
    };

    const handleCancelSave = () => {
        setConfirmModalOpenss(false);
    };



    const handleSaveConfirm = () => {
        setConfirmModalOpen(false);
        handleSubmit();
    };

    const handleSaveAndPrintConfirm = async () => {
        setConfirmModalOpens(false); // close modal


        if (mode === 'view') {
            setShowInvoice(true);
            return;
        }

        if (!ownerName.trim() || !ownerPhone.trim()) {
            toast.error("Please select or add a customer.");
            return;
        }
        if (!/^[6-9]\d{9}$/.test(ownerPhone)) {
            toast.error("Please enter a valid 10-digit phone number.");
            return;
        }
        if (!paymentMethod) {
            toast.error("Please select a payment method.");
            return;
        }
        if (items.length === 0) {
            toast.error("Please add at least one item.");
            return;
        }
        // AFTER (replace with this):
        if (handleCharge !== '' && (isNaN(handleCharge) || Number(handleCharge) < 0)) {
            toast.error("Please enter a valid Handling Charge.");
            return;
        }
        if (logisticCharge !== '' && (isNaN(logisticCharge) || Number(logisticCharge) < 0)) {
            toast.error("Please enter a valid Transport Person Charge.");
            return;
        }

        // Load Handler selected → Handling Charge required
        if (loadHandlerId && (handleCharge === '' || Number(handleCharge) <= 0)) {
            toast.error("Load Handler selected! Please enter Handling Charge.");
            return;
        }

        // Transport Person selected → Transport Charge required
        if (transportPersonId && (logisticCharge === '' || Number(logisticCharge) <= 0)) {
            toast.error("Transport Person selected! Please enter Transport Person Charge.");
            return;
        }
        if (totalAmount > 20000) {
            toast.warning(
                "⚠️ Total amount exceeds ₹20,000. Please verify the amount type before proceeding!"
            );
        }

        let savedData = null;


        // console.log(savedData,"savedData44");


        try {
            if (mode === 'add') {
                const formattedItems = items.map(item => ({
                    itemId: item.selectedItemId || '',
                    // productName: item.item,
                    productName: extractProductName(item.description),
                    productQuantity: Number(item.quantity),
                    productQuality: item.quality,
                    price: Number(item.price || 0)
                }));

                const payload = {
                    userName: ownerName,
                    phoneNumber: ownerPhone,
                    paymentMethod,
                    logisticCharge: Number(logisticCharge),
                    handleCharge: Number(handleCharge),
                    billingItems: formattedItems,
                    //  logisticId: logisticsId,
                    transportPersonId,
                    loadHandlerId,
                    sackCount: Number(sackCount) || 0,
                    boxCount: Number(boxCount) || 0,
                };

                savedData = await createBilling(payload).unwrap();
                toast.success("Billing created successfully!");
                // navigate('/dashboard/billing');

            } else if (mode === 'edit') {
                // const formattedBillingItems = items.map(item => ({
                //     billingItemId: item._id,
                //     productQuantity: Number(item.quantity),
                //     price: Number(item.price)
                // }));
                const formattedBillingItems = items.map(item => {
                    const effectivePrice =
                        Number(item?.price) > 0
                            ? Number(item.price)
                            : Number(item?.sellingPrice) > 0
                                ? Number(item.sellingPrice)
                                : 0;

                    return {
                        billingItemId: item._id,
                        productQuantity: Number(item.quantity),
                        price: effectivePrice // ✅ Only this field is sent
                    };
                });


                const payload = {
                    handleCharge: Number(handleCharge),
                    logisticCharge: Number(logisticCharge),
                    //  logisticId: logisticsId,
                    paymentMethod,
                    billingItems: formattedBillingItems,
                    transportPersonId,
                    loadHandlerId,
                    sackCount: Number(sackCount) || 0,
                    boxCount: Number(boxCount) || 0,
                };

                savedData = await updateOverallBill({ billId, payload }).unwrap();
                toast.success(savedData?.message || "Bill updated successfully!");
                //  navigate('/dashboard/billing');
            }

            localStorage.removeItem('billingItems');

            // After successful API call
            const invoiceData = {
                ...savedData.bill,
                items: savedData.billingItems || [],
                customer: savedData.customer || { firstName: ownerName, phone: ownerPhone } // default if GuestCustomer
            };

            // Pass to Invoice component
            setPrintData(invoiceData);
            setShowInvoice(true);


        } catch (err) {
            toast.error("Failed to save billing.");
            console.error("API Error:", err);
        }
    };

    const handleCancelNewCustomer = () => {
        setIsAddingNewCustomer(false);
        setNewCustomerName("");
        setNewCustomerPhone("");
        setTransportPersonId("");
        setLoadHandlerId("");
    };



    return (
        <div className={styles.billingContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>
                    {mode === 'add' && 'Create sale billing'}
                    {mode === 'edit' && 'Calculate sale Billing'}
                    {mode === 'view' && 'View sale Billing'}
                </h2>

                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.formSection}>
                    {mode !== "view" && (
                        <div className={styles.firsthead}>
                            <div className={styles.inputGroup}>
                                {!isAddingNewCustomer ? (
                                    <div className={styles.inputGroup}>

                                        <div className={styles.selectContainer}>
                                            <label className={styles.inputLabel}>Customer Name</label>
                                            <Select
                                                className={styles.customSelect}
                                                isDisabled={mode === "view" || mode === "edit"}
                                                isClearable
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "1px solid #6D6D6D",
                                                        borderRadius: "6px",
                                                        fontSize: "16px",
                                                        minHeight: "50px",
                                                        boxShadow: "none",
                                                        color: "black",
                                                        fontWeight: "600",
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: "#6D6D6D",
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                    }),
                                                }}
                                                value={
                                                    predefinedCustomers.find((cust) => cust._id === selectedCustomer)
                                                        ? {
                                                            value: selectedCustomer,
                                                            label: (() => {
                                                                const cust = predefinedCustomers.find((c) => c._id === selectedCustomer);
                                                                return cust ? `${cust.storeName ? `${cust.storeName} - ` : ""}${cust.phone} - ${cust.firstName} (Pending: ₹${cust.totalCreditAmount || 0})` : "";
                                                            })(),
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) =>
                                                    setSelectedCustomer(selectedOption ? selectedOption.value : "")
                                                }
                                                options={predefinedCustomers.map((cust) => ({
                                                    value: cust._id,
                                                    label: `${cust.storeName ? `${cust.storeName} - ` : ""}${cust.phone} - ${cust.firstName} (Pending: ₹${cust.totalCreditAmount || 0})`,
                                                }))}
                                                formatOptionLabel={(option) => {
                                                    const cust = predefinedCustomers.find(c => c._id === option.value);
                                                    if (!cust) return option.label;
                                                    const pendingAmount = cust.totalCreditAmount || 0;
                                                    return (
                                                        <span>
                                                            {cust.storeName ? `${cust.storeName} - ` : ""}
                                                            {cust.phone} - {cust.firstName}
                                                            <span style={{ color: pendingAmount > 0 ? 'red' : 'inherit', marginLeft: '5px' }}>
                                                                (Pending: ₹{pendingAmount})
                                                            </span>
                                                        </span>
                                                    );
                                                }}
                                                placeholder={
                                                    customerLoading ? "Loading..." : "Select Customer"
                                                }
                                                isSearchable
                                            />
                                            {customerError && (
                                                <p className={styles.error}>Failed to load customers.</p>
                                            )}
                                        </div>
                                        <div>
                                            {mode !== "view" && mode !== "edit" && !selectedCustomer && (
                                                <button
                                                    className={styles.addBtn}
                                                    style={{ marginTop: "6px" }}
                                                    onClick={() => {
                                                        setIsAddingNewCustomer(true);
                                                        setSelectedCustomer("");
                                                    }}
                                                >
                                                    + New Customer                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    // <>
                                    //     <label className={styles.inputLabels}>Customer Name</label>
                                    //     <input
                                    //         className={styles.input}
                                    //         type="text"
                                    //         placeholder="Enter Customer Name"
                                    //         value={newCustomerName}
                                    //         onChange={(e) => {
                                    //             let value = e.target.value;
                                    //             if (value.length === 1 && value[0] === " ") {
                                    //                 return;
                                    //             }
                                    //             setNewCustomerName(value);
                                    //         }}
                                    //         onKeyDown={(e) => {
                                    //             if (
                                    //                 (e.key === " " || e.key === "Spacebar") &&
                                    //                 newCustomerName.length === 0
                                    //             ) {
                                    //                 e.preventDefault();
                                    //             }
                                    //         }}
                                    //     />

                                    //     <label className={styles.inputLabels}>Phone Number</label>
                                    //     {/* <input
                                    //         className={styles.input}
                                    //         type="text"
                                    //         placeholder="Enter Phone Number"
                                    //         value={newCustomerPhone}
                                    //         onChange={(e) => {
                                    //             const value = e.target.value.replace(/\D/g, "");
                                    //             if (
                                    //                 value.length <= 10 &&
                                    //                 (value.length === 0 || /^[6-9]/.test(value))
                                    //             ) {
                                    //                 setNewCustomerPhone(value);
                                    //             }
                                    //         }}
                                    //         onKeyDown={(e) => {
                                    //             if (e.key === " " || e.key === "Spacebar") {
                                    //                 e.preventDefault();
                                    //             }
                                    //         }}
                                    //     /> */}
                                    //     <input
                                    //         className={styles.input}
                                    //         type="text"
                                    //         placeholder="Enter Phone Number"
                                    //         value={newCustomerPhone}
                                    //         onChange={(e) => {
                                    //             const value = e.target.value.replace(/\D/g, "");

                                    //             if (value.length <= 10) {
                                    //                 // Allow typing only up to 10 digits
                                    //                 setNewCustomerPhone(value);
                                    //             }
                                    //         }}
                                    //         onBlur={() => {
                                    //             // ✅ Validation when user leaves the input
                                    //             if (newCustomerPhone.length !== 10) {
                                    //                 toast.error("Phone number must be exactly 10 digits.");
                                    //             }
                                    //         }}
                                    //         onKeyDown={(e) => {
                                    //             if (e.key === " " || e.key === "Spacebar") {
                                    //                 e.preventDefault();
                                    //             }
                                    //         }}
                                    //     />

                                    // </>
                                    <>
                                        <label className={styles.inputLabels}>Customer Name</label>
                                        <input
                                            className={styles.inputssss}
                                            type="text"
                                            placeholder="Enter Customer Name"
                                            value={newCustomerName}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (value.length === 1 && value[0] === " ") return;
                                                setNewCustomerName(value);
                                            }}
                                            onKeyDown={(e) => {
                                                if ((e.key === " " || e.key === "Spacebar") && newCustomerName.length === 0) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        <label className={styles.inputLabels}>Phone Number</label>
                                        <input
                                            className={styles.inputssss}
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            value={newCustomerPhone}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value.length <= 10) {
                                                    setNewCustomerPhone(value);
                                                }
                                            }}
                                            onBlur={() => {
                                                if (newCustomerPhone.length !== 10) {
                                                    toast.error("Phone number must be exactly 10 digits.");
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === " " || e.key === "Spacebar") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                        {/* ✅ Action Buttons */}
                                        <div className={styles.buttonGroup}>
                                            <button
                                                className={styles.addBtn}
                                                onClick={handleCancelNewCustomer}
                                            >
                                                Cancel
                                            </button>

                                            {/* <button
                className={styles.saveBtn}
                onClick={handleSaveNewCustomer} // already irundha function
            >
                Save
            </button> */}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}


                    {(ownerName || ownerPhone) && (
                        <div className={styles.ownerBox}>
                            <p><strong>Item Owner :</strong> {ownerName}</p>
                            <p><strong>Phone No :</strong> {ownerPhone}</p>
                            {mode !== "view" && selectedCustomer && predefinedCustomers.find(c => c._id === selectedCustomer)?.storeName && (
                                <p><strong>Store Name :</strong> {predefinedCustomers.find(c => c._id === selectedCustomer).storeName}</p>
                            )}
                        </div>
                    )}
                </div>

                <div className={styles.itemsHeader}>
                    <h4>Items</h4>
                    {mode !== "view" && mode !== "edit" && (
                        <button className={styles.addItemBtn} onClick={openPopup}>+ Add Items</button>
                    )}
                </div>

                <div className={styles.itemsSection}>
                    <div className={styles.tableWrapper}>
                        <table>
                            <thead>
                                {mode === "add" ? (
                                    <tr>
                                        <th>Item ID</th>
                                        <th>Item Category</th>
                                        <th>Item Quantity</th>
                                        <th>Price</th>
                                        <th>Total Price</th>
                                        {mode !== "view" && mode !== "edit" && <th>Actions</th>}
                                    </tr>
                                ) : (
                                    <tr>
                                        {/* <th>Item ID</th> */}
                                        <th>Item ID</th>
                                        <th>Item Category</th>
                                        {mode !== "view" && <th>Buying Price</th>}
                                        {mode !== "view" && <th>Selling Price</th>}
                                        <th>Price</th>
                                        <th>Item Quantity</th>
                                        <th>Total Price</th>
                                        {mode !== "view" && mode !== "edit" && <th>Actions</th>}
                                    </tr>
                                )}
                            </thead>

                            <tbody>
                                {paginatedItems.map((item, index) => {
                                    const canEditPrice = mode === "edit" && !item.overrideOption;
                                    const quantityDisplay = Number(item.quantity) || 0;

                                    if (mode === "add") {
                                        return (
                                            // ADD MODE ROW
                                            <tr key={item._id || index}>
                                                <td>{extractItemId(item.description)}</td>
                                                {/* <td>{item.item || "-"}</td> */}
                                                <td>{extractItemCategory(item.description)}</td>
                                                <td>{quantityDisplay}kg</td>
                                                <td>
                                                    {canEditPrice ? (
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            value={item.price ?? ""}
                                                            className={styles.priceInput}
                                                            onChange={(e) => {
                                                                const updatedItems = [...items];
                                                                updatedItems[(currentPage - 1) * limit + index].price =
                                                                    Number(e.target.value);
                                                                setItems(updatedItems);
                                                            }}
                                                        />
                                                    ) : (
                                                        `₹${item.price ?? 0}`
                                                    )}
                                                </td>
                                                <td>₹{(Number(item.price) || 0) * quantityDisplay}</td>
                                                {mode !== "view" && (
                                                    <td>
                                                        <FaEdit
                                                            className={styles.icon}
                                                            onClick={() => {
                                                                setEditingItem(item);
                                                                setEditingIndex(index);
                                                                setIsPopupOpen(true);
                                                            }}
                                                        />
                                                        <FaTrashAlt
                                                            className={styles.icon}
                                                            onClick={() => confirmDelete(index)}
                                                        />
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    } else {
                                        // Non-add mode variables
                                        const itemIdDisplay = item.itemIdNumber || item.itemId || item._id || "-";
                                        const productName = item.item || "-";
                                        const bagDisplay = item.bag || "-";
                                        const overallQuantitys = item.overallQuantity || 0;




                                        return (
                                            // OTHER MODES ROW
                                            <tr key={item._id || index}>
                                                {/* <td>
                                                    {itemIdDisplay} - {productName} - {overallQuantitys} kg
                                                </td> */}
                                                {/* <td>{extractItemId(item.description)}</td> */}
                                                <td>ID {item.displayId || "-"}</td>


                                                <td>{item.item}</td>
                                                {mode !== "view" && <td>₹{item.buyingPrice ?? "-"}</td>}
                                                {mode !== "view" && <td>₹{item.sellingPrice ?? "-"}</td>}
                                                <td>
                                                    {canEditPrice ? (
                                                        // <input
                                                        //     type="number"
                                                        //     min={item.buyingPrice ?? 0}
                                                        //     // value={
                                                        //     //     (item.price == null || Number(item.price) === 0)
                                                        //     //         ? (item.itemId?.overallPrice ?? "")
                                                        //     //         : item.price
                                                        //     // }
                                                        //     value={
                                                        //         (item?.price == null || Number(item?.price) === 0)
                                                        //             ? (
                                                        //                 item?.itemId?.overallPrice ??
                                                        //                 item?.sellingPrice ??
                                                        //                 ""
                                                        //             )
                                                        //             : item?.price
                                                        //     }

                                                        //     className={styles.priceInput}
                                                        //     onChange={(e) => {
                                                        //         const updatedItems = [...items];
                                                        //         updatedItems[(currentPage - 1) * limit + index].price = Number(e.target.value);
                                                        //         setItems(updatedItems);
                                                        //     }}
                                                        //     onBlur={() => {
                                                        //         let numValue = Number(item.price);

                                                        //         if (!item.price) {
                                                        //             numValue = 0;
                                                        //         }

                                                        //         if (item.buyingPrice > 0 && item.sellingPrice > 0 && numValue > 0) {
                                                        //             if (numValue < item.buyingPrice) {
                                                        //                 toast.error(`Price cannot be less than Buying Price (₹${item.buyingPrice})`);
                                                        //                 numValue = item.buyingPrice;
                                                        //             }
                                                        //             //   if (numValue > item.sellingPrice) {
                                                        //             //     toast.error(`Price cannot be more than Selling Price (₹${item.sellingPrice})`);
                                                        //             //     numValue = item.sellingPrice;
                                                        //             //   }
                                                        //         }

                                                        //         const updatedItems = [...items];
                                                        //         updatedItems[(currentPage - 1) * limit + index].price = numValue;
                                                        //         setItems(updatedItems);
                                                        //     }}
                                                        // />
                                                        <input
                                                            type="number"
                                                            min={item.buyingPrice ?? 0}
                                                            value={
                                                                item?.price == null || Number(item?.price) === 0
                                                                    ? (
                                                                        item?.itemId?.overallPrice ??
                                                                        item?.sellingPrice ??
                                                                        ""
                                                                    )
                                                                    : item?.price
                                                            }
                                                            className={styles.priceInput}
                                                            onChange={(e) => {
                                                                const updatedItems = [...items];
                                                                updatedItems[(currentPage - 1) * limit + index].price = Number(e.target.value);
                                                                setItems(updatedItems);
                                                            }}
                                                            onBlur={() => {
                                                                let numValue = Number(item.price);

                                                                if (!item.price) {
                                                                    numValue = 0;
                                                                }

                                                                if (item.buyingPrice > 0 && item.sellingPrice > 0 && numValue > 0) {
                                                                    if (numValue < item.buyingPrice) {
                                                                        toast.error(`Price cannot be less than Buying Price (₹${item.buyingPrice})`);
                                                                        numValue = item.buyingPrice;
                                                                    }
                                                                    // Optional: uncomment this if you want to prevent exceeding selling price
                                                                    // if (numValue > item.sellingPrice) {
                                                                    //   toast.error(`Price cannot be more than Selling Price (₹${item.sellingPrice})`);
                                                                    //   numValue = item.sellingPrice;
                                                                    // }
                                                                }

                                                                const updatedItems = [...items];
                                                                updatedItems[(currentPage - 1) * limit + index].price = numValue;
                                                                setItems(updatedItems);
                                                            }}
                                                        />

                                                    ) : (
                                                        `₹${(item.price == null || Number(item.price) === 0)
                                                            ? (item.itemId?.overallPrice ?? 0)
                                                            : item.price
                                                        }`
                                                    )}
                                                </td>


                                                <td>{item?.quantity ?? "0"}</td>

                                                {/* <td>
                                                    ₹{(Number(item.price) || 0) * quantityDisplay}
                                                    </td> */}
                                                <td>
                                                    ₹{
                                                        (
                                                            Number(
                                                                item?.price && Number(item?.price) !== 0
                                                                    ? item?.price
                                                                    : item?.itemId?.overallPrice ??
                                                                    item?.sellingPrice ??
                                                                    0
                                                            ) * (Number(item?.quantity) || 0)
                                                        ).toFixed(2)
                                                    }
                                                </td>

                                                {mode !== "view" && mode !== "edit" && (
                                                    <td>
                                                        <FaEdit
                                                            className={styles.icon}
                                                            onClick={() => {
                                                                setEditingItem(item);
                                                                setEditingIndex(index);
                                                                setIsPopupOpen(true);
                                                            }}
                                                        />
                                                        <FaTrashAlt
                                                            className={styles.icon}
                                                            onClick={() => confirmDelete(index)}
                                                        />
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    }
                                })}

                                {paginatedItems.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan={mode === "add" ? 6 : 8}
                                            className={styles.noData}
                                            style={{ textAlign: "center" }}
                                        >
                                            No items found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                    </div>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>

                <div className={styles.totalSection}>

                    <div className={styles.amountDetails}>
                        <div className={styles.paddingsec}>

                            <div>


                                {/* Load Handler */}
                                <div >
                                    {/* <label className={styles.inputLabelone}>Load Handler</label> */}
                                    <Select
                                        isDisabled={mode === "view"}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                border: "1px solid #6D6D6D",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                minHeight: "50px",
                                                boxShadow: "none",
                                                color: "black",
                                                fontWeight: "600",
                                                width: "405px",
                                                marginBottom: "15px"
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#6D6D6D",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                            }),
                                        }}
                                        value={
                                            loadHandlerList.find(e => e._id === loadHandlerId)
                                                ? { value: loadHandlerId, label: loadHandlerList.find(e => e._id === loadHandlerId)?.name }
                                                : null
                                        }
                                        onChange={(opt) => setLoadHandlerId(opt ? opt.value : "")}
                                        options={loadHandlerList.map(e => ({ value: e._id, label: `${e.name} - ${e.phone}` }))}
                                        placeholder="Select Load Handler"
                                        isSearchable
                                        isClearable
                                    />
                                </div>
                            </div>
                            <div >
                                {/* Transport Person */}
                                <div >
                                    {/* <label className={styles.inputLabelone}>Transport Person</label> */}
                                    <Select

                                        isDisabled={mode === "view"}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                border: "1px solid #6D6D6D",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                minHeight: "50px",
                                                boxShadow: "none",
                                                color: "black",
                                                fontWeight: "600",
                                                width: "405px",
                                                marginBottom: "10px"
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#6D6D6D",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                            }),
                                        }}
                                        value={
                                            transportList.find(e => e._id === transportPersonId)
                                                ? { value: transportPersonId, label: transportList.find(e => e._id === transportPersonId)?.name }
                                                : null
                                        }
                                        onChange={(opt) => setTransportPersonId(opt ? opt.value : "")}
                                        options={transportList.map(e => ({ value: e._id, label: `${e.name} - ${e.phone}` }))}
                                        placeholder="Select Transport Person"
                                        isSearchable
                                        isClearable
                                    />
                                </div>
                            </div>
                            <div>
                                {/* <div
                                    // className={styles.inputGroup}
                                    className={`${styles.inputGroup} ${mode === "view" ? styles.dflexxx : styles.inputGroup
                                        }`}
                                >
                                    <label className={styles.inputLabelone}>Assest </label>

                                    <select
                                        // className={styles.inputs}
                                        className={`${styles.inputs} ${mode === "view" ? styles.inputsseleted : styles.inputs
                                            }`}
                                        value={logisticsId}
                                        onChange={(e) => setLogisticsId(e.target.value)}
                                        disabled={mode === "view"}
                                    >
                                        <option value="">Select Assest</option>

                                        <option value="box">Box</option>
                                        <option value="sack">Sack</option>

                                    </select>
                                </div> */}
                                <div className={styles.dflex}>


                                    <div >
                                        <div>
                                            <label className={styles.inputLabels}>Box Count</label>
                                        </div>
                                        <input
                                            className={`${styles.inputnew} ${mode === "view" ? styles.inputlasttwo : styles.input
                                                }`}
                                            type="number"
                                            placeholder="Enter Box count"
                                            value={boxCount}
                                            onChange={(e) => setBoxCount(e.target.value)}
                                            readOnly={mode === "view"}
                                        />
                                    </div>
                                    <div >
                                        <div>
                                            <label className={styles.inputLabels}>Sack Count</label>
                                        </div>
                                        <input
                                            className={`${styles.inputnew} ${mode === "view" ? styles.inputlasttwo : styles.input
                                                }`}
                                            type="number"
                                            placeholder="Enter Sack Count"
                                            value={sackCount}
                                            onChange={(e) => setSackCount(e.target.value)}
                                            readOnly={mode === "view"}
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className={styles.dflexs}>
                            {/* <h4>Total </h4> */}

                            <div className={styles.dflex}>
                                <div>
                                    <label className={styles.inputLabels}>Handler Charge</label>
                                </div>
                                <input
                                    //className={styles.input}
                                    className={`${styles.input} ${mode === "view" ? styles.inputlasttwo : styles.input
                                        }`}
                                    type="number"
                                    placeholder="Enter Handling Charge"
                                    value={handleCharge}
                                    onChange={(e) => setHandleCharge(Number(e.target.value))}
                                    readOnly={mode === "view"}
                                />
                            </div>
                            <div className={styles.dflex}>
                                <div>
                                    <label className={styles.inputLabels}>Transport Person Charge</label>
                                </div>
                                <input
                                    // className={styles.input}
                                    className={`${styles.input} ${mode === "view" ? styles.inputlasttwo : styles.input
                                        }`}
                                    type="number"
                                    placeholder="Enter Transport Person Charge"
                                    value={logisticCharge}
                                    onChange={(e) => setLogisticCharge(Number(e.target.value))}
                                    readOnly={mode === "view"}
                                />
                            </div>
                            <div className={styles.dflex}>
                                <div className={styles.mt}>
                                    <div><p><strong className={styles.mttext}>Total Amount</strong></p></div>
                                    <p className={styles.mttext}>₹ <strong className={styles.mttext}>{totalAmount.toFixed(2)}</strong></p>
                                </div>

                            </div>

                        </div>
                    </div>
                    <hr />
                    <div className={styles.headpayment}>
                        <div className={styles.emptydiv}></div>
                        <div className={styles.emptydiv}>
                            <div className={styles.dflex}>
                                <div className={styles.finalssss}>
                                    <label className={styles.inputLabels}>Payment Type</label>
                                </div>
                                <select
                                    //className={styles.inputs}
                                    className={`${styles.inputspay} ${mode === "view" ? styles.inputsseleted : styles.inputspay
                                        }`}
                                    value={paymentMethod}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                    disabled={mode === "view"}
                                >
                                    <option value="">Select Payment Type</option>
                                    <option value="cash">Cash</option>
                                    <option value="upi">UPI</option>
                                    <option value="credit">Credit</option>
                                    <option value="bank">Bank</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>

                {/* <div className={styles.footerButtons}>
                    <button className={styles.cancelBtn} onClick={handleClose}>Cancel</button>
                    {mode !== 'view' && (
                        <button className={styles.saveBtn} onClick={handleSubmit} disabled={creating}>
                            {creating ? 'Saving...' : mode === 'edit' ? 'Update' : 'Save'}
                        </button>
                    )}
                </div> */}

                {/* <div className={styles.footerButtons}>
                    <button className={styles.cancelBtn} onClick={handleClose}>Cancel</button>
                    {mode !== 'view' && (
                        <button
                            className={styles.saveBtn}
                            onClick={handleSaveClick}
                            disabled={creating}
                        >
                            {creating ? 'Saving...' : mode === 'edit' ? 'Update' : 'Save'}
                        </button>
                    )}
                    <button
                        className={styles.saveBtn}
                        onClick={() => setConfirmModalOpens(true)}
                        disabled={creating}
                    >
                        Save And Print
                    </button>

                </div> */}

                <div className={styles.footerButtons}>
                    {mode === 'view' ? (
                        <>
                            <button className={styles.cancelBtn} onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                className={styles.saveBtn}
                                onClick={() => setShowInvoice(true)}
                            >
                                Print
                            </button>
                        </>
                    ) : (
                        <>
                            <button className={styles.cancelBtn} onClick={handleClose}>
                                Cancel
                            </button>
                            {/* <button
                                className={styles.saveBtn}
                                onClick={handleSaveClick}
                                disabled={creating}
                            >
                                {creating ? 'Saving...' : mode === 'edit' ? 'Update' : 'Save'}
                            </button> */}
                            <button
                                className={styles.saveBtn}
                                onClick={handleSaveClick}
                                disabled={creating}
                            >
                                {creating ? 'Saving...' : mode === 'edit' ? 'Calculate' : 'Sell'}
                            </button>

                            {/* <button
                                className={styles.saveBtn}
                                onClick={() => setConfirmModalOpens(true)}
                                disabled={creating}
                            >
                                Save And Print
                            </button> */}
                            {mode === 'add' && (
                                <button
                                    className={styles.saveBtn}
                                    onClick={() => setConfirmModalOpens(true)}
                                    disabled={creating}
                                >
                                    Sell & Print
                                </button>
                            )}
                        </>
                    )}
                </div>



            </div>



            {isPopupOpen && (
                <PopupWrapper onClose={closePopup}>
                    <AddIBillingPopup
                        itemData={editingItem}
                        isEditMode={!!editingItem}
                        editIndex={editingIndex}
                        onClose={() => {
                            setEditingItem(null);
                            setEditingIndex(null);
                            closePopup();
                        }}
                    />
                </PopupWrapper>
            )}

            <DeleteConfirmModalLogout
                isOpen={confirmModalOpen}
                onConfirm={handleSaveConfirm}
                onCancel={() => setConfirmModalOpen(false)}
                title="Are you sure?"
                heading="Confirm Calculation"
                content="Once verified, you will not be able to access Update Billing. Do you want to continue?"
            />

            <DeleteConfirmModalLogout
                isOpen={deleteConfirmOpen}
                onConfirm={handleConfirmedDelete}
                onCancel={() => setDeleteConfirmOpen(false)}
                title="Are You Sure?"
                heading="Delete Confirmation"
                content="Do you want to delete this item from the billing list?"
            />

            <DeleteConfirmModalLogout
                isOpen={confirmModalOpens}
                onConfirm={handleSaveAndPrintConfirm} // use the new handler
                onCancel={() => setConfirmModalOpens(false)}
                title="Are you sure?"
                heading="Confirm Save & Print"
                content="Once confirmed, the billing will be saved and print will be triggered. Do you want to continue?"
            />
            <DeleteConfirmModalLogout
                isOpen={confirmModalOpenss}
                onConfirm={handleConfirmSave}
                onCancel={handleCancelSave}
                title={mode === "edit" ? "Confirm Update" : "Confirm Sell"}
                heading={mode === "edit" ? "Update Confirmation" : "Sale Confirmation"}
                content={
                    mode === "edit"
                        ? "Do you want to update  this sales?"
                        : "Do you want to confirm this sales?"
                }
            />

            {
                showInvoice && printData && (
                    // <InvoiceDesign
                    //     data={printData}
                    //     onClose={() => setShowInvoice(false)}
                    // />

                    <PopupWrapper onClose={() => setShowInvoice(false)}>
                        <div className={styles.popupHeader}>
                            <div className={styles.header}>
                                <h2 className={styles.tittle}>Share</h2>
                                <span className={styles.closeIcon} onClick={() => {
                                    setShowInvoice(false); // close the invoice popup
                                    // Optional: navigate after closing
                                    navigate("/dashboard/billing");
                                }}>
                                    ✕
                                </span>
                            </div>

                            {/* Only Thermal Print */}
                            <div className={styles.tabContent}>
                                <div className={styles.invoicePreview}>
                                    <InvoiceDesignAddBilling
                                        mode="thermal"
                                        data={printData}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopupWrapper>

                )
            }


        </div >
    );
};

export default AddBilling;

